<template>
  <div class="report-wrapper">
    <div class="report-header">
      <app-btn @click="goBack()">{{$ml.get('Back')}}</app-btn>
    </div>
    <div class="report">
      <div class="water-test">
    <!-- <NutrientSummary/> -->
        <div class="html2pdf__page-break">
        <MainHeader>
          {{$ml.get('Water test')}}
        </MainHeader>
      
        <GeneralInfo/>
        <NForms/>
        <Nutrients/>
        <Irrigation v-if="section.data.irrigation"/>
        </div>
        <NFormsChart/>
      </div>
    </div>
  </div>
</template>

<script>
import NFormsChart from '@/views/tests/reports/water/NFormsChart';
import GeneralInfo from '@/views/tests/reports/water/GeneralInfo';
import Irrigation from '@/views/tests/reports/water/Irrigation';
import NForms from '@/views/tests/reports/water/NForms';
import Nutrients from '@/views/tests/reports/water/Nutrients';
import MainHeader from '@/views/tests/reports/common/MainHeader';

import { mapGetters } from 'vuex'

export default {
  components: {
    MainHeader,
    GeneralInfo,
    Irrigation,
    NForms,
    Nutrients,
    NFormsChart,
  },
  methods: {
    
    goBack() {
      this.$store.commit('pdf/removeData');
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.$root.data = this.data;
    console.log(this.$root.data)
  },
  mounted() {
    console.log(Object.keys(this.data).length)
    if(Object.keys(this.data).length === 0) {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters({
      data: 'pdf/data'
    }),
    section() {
      return this.data.waterTest;
    }
  }
}
</script>

<style lang="scss" scoped>

.tissue-test {
  .head-line {
    margin-bottom: 10px;
  }
}

</style>